'use client';
import React, { startTransition } from 'react';
import { useContext, useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import PageLoaderContext from './_contexts/page-loader-context/PageLoaderContext';
import PrimaryButton from '@/app/_components/buttons/primary-button/PrimaryButton';
import SecondaryButton from '@/app/_components/buttons/secondary-button/SecondaryButton';

import styles from './error.module.scss';
type Props = {};

export default function ErrorComponent({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { setIsPageLoading, isPageLoading } = useContext(PageLoaderContext);
  const pathname = usePathname();
  const router = useRouter();
  // console.log('Error from global-errors/error.tsx', error);

  useEffect(() => {
    if (isPageLoading) {
      setIsPageLoading(false);
    }
  }, [isPageLoading]);

  const goToAboutPageHandle = () => {
    window.location.assign('/about');
  };

  const resetHandler = () => {
    // window.location.reload();
    startTransition(() => {
      router.refresh();
      reset();
    });
  };

  return (
    <div className={styles.pageWrapper}>
      <section className={styles.errorWrapper}>
        <h1>Something went wrong</h1>
        <p>
          The error occured on page:{' '}
          <span className={styles.route}>{pathname}</span>
        </p>
        <p>
          Error Message: <span>{error.message}</span>
        </p>

        <h2>Try again, or try logout and back in again.</h2>

        {/* <button onClick={() => reset()}>Try again</button> */}
        <div className={styles.btnWrapper}>
          <PrimaryButton
            label="Try again"
            disabled={false}
            onClick={resetHandler}
          />

          <SecondaryButton
            label="Go to About Page"
            disabled={false}
            onClick={goToAboutPageHandle}
          />
          <a className={styles.logout} href="/auth/logout?reason=error">
            Logout
          </a>
        </div>
      </section>
    </div>
  );
}
